export default {
    code: 'cn',
    submit: '提交',
    ok: '确定',
    coopSuccess: '提交成功，稍后商务会与您联系！',
    coop: '商务合作',
    friendLink: '友情链接',
    companyAddress: '中保华安集团有限公司',
    wechatService: '官方微信',
    china: '国内',
    oversea: '境外',
    coopBusiness: '合作业务',
    coopCompany: '您的公司',
    coopCity: '您所在的城市',
    coopName: '您的姓名',
    coopPhone: '您的电话',
    coopEmail: '您的邮箱',
    inputBusiness: '请选择合作业务',
    inputCompany: '请填写您的公司',
    inputBirthday: '请填写您所在的城市',
    inputName: '请填写您的姓名',
    inputPhone: '请填写您的电话',
    realPhone: '电话格式或位数不符合，提交失败',
    inputEmail: '请填写您的邮箱',
    companyStyle: '企业风采',
    about: '关于我们',
    spread: '展开更多',
    addressTitle: '总部地址',
    recruitPost: '职位名称',
    recruitAddress: '工作地点',
    recruitDegree: '学历要求',
    recruitExp: '工作年限',
    recruitSalary: '薪酬范围',
    recruitDuty: '工作职责',
    recruitContent: '任职要求',
    toDetail: '查看详情',
    cateAll: '全部分类',
    address: '地址',
    fax: '传真',
    phone: '总机',
    postCode: '邮编',
    website: '网址',
    pubAt: '发布于',
    service: '服务中心',
    productBuy: '产品购买',
    productPay: '订单支付',
    buySubmit: '订单提交',
    buyConfirm: '订单确认',
    customPrice: '定制价格',
    buyCountry: '行程国家',
    inputBuyCountry: '行程国家字段，未填写',
    buyLastname: '购买人姓',
    inputBuyLastname: '购买人姓字段，未填写',
    buyFirstname: '购买人名',
    inputBuyFirstname: '购买人名字段，未填写',
    buyCellphone: '手机号',
    inputBuyCellphone: '手机号字段，未填写',
    realBuyCellphone: '手机号格式不正确，请输入数字',
    inputCountryCode: '手机号国号字段，未填写',
    realCountryCode: '手机号国号格式不正确，请输入"+数字"',
    buyIdentity: '身份证号',
    inputBuyIdentity: '身份证号字段，未填写',
    realBuyIdentity: '身份证格式错误',
    buyPassport: '护照号',
    inputBuyPassport: '护照号字段，未填写',
    realBuyPassport: '护照号格式不正确，请输入数字+字母',
    choosePay: '请选择支付方式',
    tips: '提示',
    payFail: '支付失败，请联系客服处理400 821 0904',
    orderFail: '订单提交失败，请联系客服处理400 821 0904',
    wechatPay: '微信支付',
    alipay: '支付宝支付',
    payConfirm: '确认支付',
    paySuccess: '您的订单以及支付成功，请下载APP查看！',
    buySuccess: '订单已提交稍后客服与您联系！也可下载手机客户端了解实时情况！',
    app: '手机客户端',
};
